module.exports = __webpack_public_path__ + "img/CAE24E_6C9A23_A3C737_B3D43C-256px.3a8fef0d.png";